<template>
    <canvas ref="chart" height="300" width="100"></canvas>
</template>

<script>
import Chart from 'chart.js';
import chartAPI from './../../services/sales/chart';

export default {
    data() {
        return {
            data: [],
            backgroundColors: ["#f1948a ", " #c39bd3 ", "  #85c1e9  ", " #82e0aa ", " #f8c471 "],
            chart: null
        }
    },
    computed: {
        datasets() {
            return [{
                label: "Last Week New Customers Per Day",
                data: this.data.map(each => ({x: each.day, y: each.count})),
                fill: false,
                borderColor: this.backgroundColors[2],
                backgroundColor: "rgba(187, 143, 206, 0.3)",
                tension: 0.3
            }]
        },
        labels() {
            return this.data.map(each => each.day)
        }
    },
    watch: {
        datasets(value) {
            this.chart.data.datasets = value;
            this.chart.data.labels = this.labels;
            this.chart.update();
        }
    },
    methods: {
        renderChart() {
            this.chart = new Chart(this.$refs.chart, {
                type: "line",
                data: {
                    labels: this.labels,
                    datasets: []
                },
                options: {
                    maintainAspectRatio: false,
                    responsive: true,
                    title: {
                        text: "Last Week New Customers Per Day",
                        display: true
                    },
                }
            })
        },
        async fetch() {
            let res = await chartAPI.newCustomersPerWeek();
            this.data = res.data;
        }
    },
    mounted() {
        this.renderChart();
        this.fetch();
    },
}
</script>

<style>

</style>

